import React, {useEffect, useState} from 'react';

import {Link, Navigate, useParams} from "react-router-dom";
import {connect} from "react-redux";
import {changeTitle, unlockGuidebook} from "../../actions";
import {Trans, withTranslation} from 'react-i18next';
import {getUrl, PWAUrls} from "../../config/urls";
import Swal from 'sweetalert2';
import OImg from "../../components/OImg";
import {compose} from 'redux';
import ErrorRequestHandler from "../../components/ErrorRequestHandler";
import {Alert, Container} from '@mui/material';
import {useAuth} from "../../context/auth-context";
import AlertComponent from "../../components/AlertComponent";
import {useGuidebookValidation} from "../../hooks/useGuidebook";
import {MuiButton} from "../../components/MuiButton";
import {useNavigate} from "react-router";
import {toast} from "react-toastify";
import usePostTopoValidation from "../../hooks/usePostTopoValidation";

const TopoValidationScreen = ({t, i18n,onTitleChange}) => {
    const auth = useAuth();
    const history = useNavigate();
    const [fields, setFields] = useState({});
    const [question, setQuestion] = useState(null);
    const [errors, setErrors] = useState(false);

    if (auth.isAuthenticated && typeof fields['email'] === "undefined") {
        setFields({
            ...fields,
            ['email']: auth.user.email,
        });
    }

    useEffect(() => {
        onTitleChange(t("TopoValidationScreen.title"));
    }, [t]);

    const {slug} = useParams();

    const {status, data, error} = useGuidebookValidation(slug, i18n.language);

    if (!auth.isAuthenticated) {
        return (<AlertComponent
            title={t("TopoValidationScreen.title")}
            message={t("TopoValidationScreen.alert.guestMessage")}
            severity={'warning'}
            reload={false}
            backgroundIcon={'book'}
            ctaLabel={t("TopoValidationScreen.alert.guestCta")}
            ctaIcon={'sign-in-alt'}
            ctaLinkTo={getUrl(PWAUrls.USER_LOGIN, {lng: i18n.language})}
        />)
    }

    let label = "";

    const getRandomQuestion = (data) => {
        if (typeof data.questions !== 'undefined' && data.questions.length > 0) {
            let question = data.questions[(Math.floor(Math.random() * Math.floor(data.questions.length)))]
            if (question) {
                return question;
            }
        }
        return null;
    };

    const handleChange = (field, e) => {
        fields[field] = e.target.value;
        setFields({
            ...fields,
            [field]: e.target.value
        });
    };
    const {data: dataTopoValidation, mutateAsync, status: statusTopoValidation, error: errorTopoValidation } = usePostTopoValidation(i18n.language);
    const verificationSubmit = async (e) => {
        e.preventDefault();

        try {
            await mutateAsync(fields);
        } catch (e) {
            toast.error(t('TopoValidationScreen.popin.error.title'));
        }
    };

    useEffect(() => {
        if (dataTopoValidation && typeof dataTopoValidation !== "undefined") {
            Swal.fire({
                titleText: t('TopoValidationScreen.popin.title.success'),
                icon: 'success',
                text: t('TopoValidationScreen.popin.description.success'),
                showCancelButton: true,
                confirmButtonText: t('TopoValidationScreen.popin.button.typeCode'),
                cancelButtonText: t('TopoValidationScreen.popin.button.ok'),
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    history(getUrl(PWAUrls.TOPO, {lng: i18n.language, slug: slug}));
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    history(getUrl(PWAUrls.HOME, {lng: i18n.language}));
                }
            })
        }
    }, [dataTopoValidation]);

    if (status === "success" && data.questions.length > 0 && question === null) {
        label = data.guidebook.label;
        const question = getRandomQuestion(data);

        setQuestion(question);
        setFields({...fields,
            question: question?.id,
            email: auth.user.email,
        });
    }

    return (
        <Container maxWidth="lg" className="TopoValidationScreen">
            {status  === 'pending' && <div className={"loadingWrapper"}>
                <div id="loading"/>
            </div>}

            {status === 'error' && error && <ErrorRequestHandler error={error}/>}

            {status === 'success' && <div className="topoValidationContent mt-3 mb-3">
                <div className="row">
                    <div className="col-4">
                        <OImg src={data.guidebook.media_big_url}/>
                    </div>
                    <div className="col-8">
                        <h2 className="mt-0">{data.guidebook.label}</h2>
                        <p className="wysiwyg" dangerouslySetInnerHTML={{__html: data.guidebook.descriptionShort}}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <p>
                            <Trans i18nKey="TopoValidationScreen.description" label={data.guidebook.label}>
                                Pour avoir accès au contenu numérisé du topo {{label}} vous devez posséder
                                le livre et vous enregistrer.<br/>
                                Pour cela il faut renseigner votre adresse e-mail et répondre à la question
                                ci-dessous ou saisir un code d'activation<br/>
                            </Trans>

                        </p>
                        {question === null && <>
                            <Alert severity={'warning'}>{t('TopoValidationScreen.alert.missingQuestion')}</Alert>
                            <div className={'centerButton'}>
                                <MuiButton component={Link} className="mb-3 mt-3" variant={'outlined'} color="primary"
                                           to={'..'}
                                           onClick={(e) => {
                                               e.preventDefault();
                                               history(-1);
                                           }}>
                                    {t('common.back')}
                                </MuiButton>
                            </div>
                        </>}
                        {question !== null && <form name={"validationForm"} className={'validationForm'}
                                                    onSubmit={verificationSubmit}
                        >
                            <div className="form-group">
                                <label htmlFor="response">{question.content}</label>
                                <input type="text" className="form-control" id="response" name={'response'}
                                       onChange={(e) => {
                                           handleChange("response", e)
                                       }}
                                       value={fields["response"] || ''}
                                       placeholder={t('TopoValidationScreen.form.input.reponse.placeholder')}/>
                            </div>


                            {/*<p className="text-secondary w-100 text-center">*/}
                            {/*    <b>{t('TopoValidationScreen.form.help')}</b>*/}
                            {/*</p>*/}
                            <Link className={'centerButton'} to={"/" + data.guidebook.type + "/" + data.guidebook.slug}>
                            </Link>

                            <div className={'centerButton'}>
                                <MuiButton component={Link} className="mb-3" variant={'outlined'} color="primary" to={'..'}
                                           onClick={(e) => {
                                               e.preventDefault();
                                               history(-1);
                                           }}>
                                    {t('common.back')}
                                </MuiButton>

                                <MuiButton className="ml-4 mb-3" variant="contained" type="submit" disabled={statusTopoValidation === "pending"}>
                                    {t('TopoValidationScreen.form.input.submit.text')}
                                </MuiButton>
                            </div>
                        </form>}

                    </div>
                </div>
            </div>}
        </Container>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onTitleChange: (title) => {
            dispatch(changeTitle(title))
        },
        unlockGuidbook: (guidebookId) => {
            dispatch(unlockGuidebook(guidebookId))
        }
    }
};

export default
    compose(
        withTranslation(),
        connect(
            null,
            mapDispatchToProps
    ))(TopoValidationScreen);